import { render, staticRenderFns } from "./MessageCardPlainPreview.vue?vue&type=template&id=24dc7b54&scoped=true&"
import script from "./MessageCardPlainPreview.vue?vue&type=script&lang=ts&"
export * from "./MessageCardPlainPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCardPlainPreview.vue?vue&type=style&index=0&id=24dc7b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc7b54",
  null
  
)

export default component.exports